export default __webpack_public_path__ + "static/img/projections-transition.a3cb69f.png";